import React, { useState } from 'react';
import axios from 'axios';
import backendUrl from '../BackendUrl';

const UploadImage = ({ uploadUrl, id, onUploadSuccess }) => {
    const [image, setImage] = useState(null);
    const adminToken = localStorage.getItem('adminToken');

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file);
    };

    const handleImageUpload = async () => {
        if (!image) {
            alert("Please select an image to upload.");
            return;
        }
        
        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("User not authenticated. Please log in.");
            return;
        }
    
        // Convert file to base64
        const toBase64 = (file) => 
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]); // Extract Base64 part
                reader.onerror = (error) => reject(error);
            });
    
        try {
            const base64Image = await toBase64(image);
    
            const response = await axios.post(`${backendUrl}${uploadUrl}`, 
                {
                    file: base64Image,
                    id: id, 
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${adminToken}`,
                    },
                }
            );
    
            alert("Image uploaded successfully!");
            if (onUploadSuccess) {
                onUploadSuccess(response.data.classImg);
            }
        } catch (error) {
            console.error("Error uploading image:", error);
            alert("Failed to upload image. Please try again.");
        }
    };    

    return (
        <div className="image-upload-section">
            <label htmlFor="imageUpload">Choose Image:</label>
            <input type="file" id="imageUpload" onChange={handleImageChange} />
            <button type="button" onClick={handleImageUpload}>Upload Image</button>
        </div>
    );
};

export default UploadImage;